module.exports = __webpack_public_path__ + "img/cz.047e732d.svg";